import { required, Validator } from '@/entities/validation';
import { IssueDetailData } from '@/entities/issue/public/model';

export const validate: Validator<IssueDetailData> = todo => [
  ...required(todo.status.toString(), 'status'),
];
